import { render, staticRenderFns } from "./DeclarationsList.vue?vue&type=template&id=690c1a0c&scoped=true&"
import script from "./DeclarationsList.vue?vue&type=script&lang=js&"
export * from "./DeclarationsList.vue?vue&type=script&lang=js&"
import style0 from "./DeclarationsList.vue?vue&type=style&index=0&id=690c1a0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690c1a0c",
  null
  
)

export default component.exports